module.exports = __webpack_public_path__ + "static/o-t-01-cde7a9234f1aff7efd60071d84ca4568.jpg";